import { AJOUTER_DISPONIBILITE_AVOIRS } from './actionTypes'

export const ajouterDisponibiliteAvoirs = (disponibiliteAvoirs) => {
	return ({
		type: AJOUTER_DISPONIBILITE_AVOIRS,
		payload: disponibiliteAvoirs
	})
}
